module.exports = __webpack_public_path__ + "img/logo-rbh-go.8b8543d3.png";